<script lang="ts" setup>
  import { Modal } from '@tundr/modal';
  import { SidePanel } from '@tundr/side-panel';
  import { Slideover } from '@tundr/slideover';
  import { ToastPresenter } from '@tundr/toast';
  import { GLOBAL_OVERLAYS_TARGET } from '@tundr/ui-kit';
</script>

<template>
  <div :class="GLOBAL_OVERLAYS_TARGET" />
  <Modal />
  <SidePanel />
  <Slideover />
  <ToastPresenter />
</template>
